import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { DatePicker } from "antd";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import CreatePolicyMapping from "./CreatePolicyMapping";

import {
  RemoveRedEyeIcon,
  SearchIcon,
  DeleteIcon,
  CloudOffIcon,
  AddIcon,
} from "../../../Resources/Icons/icons";

import {
  GetUser,
  GetBranch,
  DeleteBranch,
  GetPolicyFileById,
  GetBookingCode,
  GetPolicyMapping,
  GetPolicyMappingByPolicyID,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MappingDone from "./MapingDone";
import moment from "moment";
import Loader from "../../../UiComponents/Loader/Loader";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TabFilter from "../../Tabs/Tabs";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : "";
};

const headCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Premium",
  },
  {
    id: "creatingUser",
    placeMent: true,
    disablePadding: false,
    label: "Creating User",
  },
  {
    id: "policyTableUser",
    placeMent: true,
    disablePadding: false,
    label: "Policy Table User",
  },
  // {
  //   id: "action",
  //   placeMent: true,
  //   disablePadding: false,
  //   label: "Action",
  //   type: "button",
  //   buttonLabel: "Mapping",
  //   buttonColor: "success",
  //   buttonClass: "Common_Button",
  // },
];

const FilterOption = [
  {
    label: "Pending",
    isEnabled: "true",
    value: 1,
  },
  {
    label: "Approved",
    isEnabled: "false",
    value: 2,
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const PolicyMapping = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openMapingDoneDrawer, setOpenMapingDonedrawer] = useState(false);
  const [mappingData, setMappingData] = React.useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [openLoader, setOpenLoader] = useState(false);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [selectedTab, setSelectedTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: false,
    isEdit: false,
    isMapping: true,
    isDelete: false,
    isSearch: true,
    isApprove: false,
  });
  const [dateRange, setDateRange] = useState(null);

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(mappingData), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, mappingData]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const CreatePolicyMappingData = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el.company},${el.policyNumber},${el.totalPremium},${el.creatingUser
              },${el.policyTableUser},${moment(el?.policyDate).format(
                "DD-MM-YYYY"
              )}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const FilteredData = mappingData.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const mappingDataDetails =
      `${el?.company},${el?.policyNumber},${el?.totalPremium},${el?.creatingUser},${el?.policyTableUser}`.toLowerCase();
    return mappingDataDetails.includes(searchTerm);
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    if (selectedOption.value === 1) {
      // ActiveFunction();
      FilterFunction("Pending");
    } else if (selectedOption.value === 2) {
      // DisableFunction();
      FilterFunction("Approved");
    }
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      const FilteredData = res.data.map((e) => {
        if (e.isEnabled && e?.userType.includes("user")) {
          return {
            ...e,
            label: e.name + " - " + e.mobileNumber + " - " + e.email,
            value: e._id,
          };
        } else {
          return null;
        }
      });
      setUserDetails(FilteredData.filter(Boolean));
    });
  };

  const GetData = () => {
    setOpenLoader(true);
    const requesttype = "Pending";
    GetPolicyMapping(requesttype)
      .then((res) => {
        if (res?.data) {
          const data = res.data.map((e) => {
            return {
              ...e,
              policyDate: moment(e?.policyDate).format("DD/MM/YYYY"),
            };
          });
          setMappingData(data);
        }
      })
      .catch((error) => {
        console.error("Error fetching policy mapping data:", error);
        setMappingData([]);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };
  React.useEffect(() => {
    GetData();
    GetUserDetails();
  }, []);

  const FilterFunction = (key) => {
    setOpenLoader(true);
    const requesttype = key === "Pending" ? "Pending" : "Approved";
    const mappinguserid = selectedUser ? selectedUser : null;
    // Extract dates from dateRange - only pass if dateRange is set and has valid dates
    // Format dates to ISO format (2025-10-31T18:30:00.000Z)
    // const selectedStartDate =
    //   dateRange && Array.isArray(dateRange) && dateRange[0]
    //     ? dateRange[0].toISOString
    //       ? dateRange[0].toISOString()
    //       : moment(dateRange[0]).toISOString()
    //     : null;
    // const selectedEndDate =
    //   dateRange && Array.isArray(dateRange) && dateRange[1]
    //     ? dateRange[1].toISOString
    //       ? dateRange[1].toISOString()
    //       : moment(dateRange[1]).toISOString()
    //     : null;
    const selectedStartDate = dateRange?.[0]
      ? moment(dateRange[0]?.$d).format("DD-MM-YYYY")
      : null;

    const selectedEndDate = dateRange?.[1]
      ? moment(dateRange[1]?.$d).format("DD-MM-YYYY")
      : null;

    GetPolicyMapping(
      requesttype,
      mappinguserid,
      selectedStartDate,
      selectedEndDate
    )
      .then((res) => {

        if (res?.data) {
          const data = res.data.map((e) => {
            return {
              ...e,
              policyDate: moment(e?.policyDate).format("DD/MM/YYYY"),
            };
          });
          setMappingData(data);
          setPage(0);
        }
      })
      .catch((error) => {
        console.error("Error filtering policy mapping data:", error);
        setMappingData([]);
        setPage(0);
      })
      .finally(() => {
        setOpenLoader(false); // Stop loading
      });
  };

  // useEffect(() => {
  //   // console.log('Changing',dateRange)
  //   const requestType = selectedTab === 1 ? "Pending" : "Approved";
  //   FilterFunction(requestType)
  // }, [dateRange]);
  const MappingFunction = (row) => {
    setOpenMapingDonedrawer(true);
    GetPolicyMappingByPolicyID(row._id).then((res) => {
      setSelectedData(res.data);
    });
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  // const implementCond = (cell) => {
  //   return cell.map((obj) =>
  //     obj.id === "action"
  //       ? {
  //           ...obj,
  //           condition: (row) => true,
  //         }
  //       : obj
  //   );
  // };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleClearAllState = () => {
    setSelectedUser(null);
    setDateRange(null);
    setSearchTrigger((prev) => prev + 1);
  };

  const handleSaveAllFilter = () => {
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      const requestType = selectedTab === 1 ? "Pending" : "Approved";
      FilterFunction(requestType);
    }
  }, [searchTrigger]);

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      // Clear user filter
      setSelectedUser(null);
    } else if (filterId === 2) {
      // Clear date filter
      setDateRange(null);
    }
    setSearchTrigger((prev) => prev + 1);
  };

  const filterBoxData = [
    {
      id: 1,
      label: "Select User",
      data: userDetails,
      setState: setSelectedUser,
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Date",
      setDate: (e) => {
        setDateRange(e);
        setSearchTrigger((prev) => prev + 1);
      },
      value: dateRange,
      type: "noDefaultDate",
    },
  ];

  const activeFiltersCount = [
    selectedUser,
    dateRange?.length > 0 ? 1 : 0,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Policy Mapping
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          color="error"
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_create_Button w-100"
                      startIcon={
                        <AddIcon
                          sx={{
                            marginRight: "1.5px",
                          }}
                        />
                      }
                      onClick={CreatePolicyMappingData}
                    >
                      Create
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                {/* <Grid item xs={12} sm={8} md={8}></Grid> */}
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search User"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={headCells}
                // columns={implementCond(headCells)}
                // isServerSide={true}
                handleOnClickBehaviour={OpenPolicyFile}
                handleMapping={MappingFunction}
                // handleButton={{
                //   Mapping: MappingFunction,
                // }}
                tableTotalCount={filter.fn(mappingData)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openDrawer ? (
          <CreatePolicyMapping
            setOpenDrawer={setOpenDrawer}
            GetData={GetData}
          />
        ) : null}
      </Drawer>

      <Drawer
        open={openMapingDoneDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openMapingDoneDrawer ? (
          <MappingDone
            setOpenMapingDonedrawer={setOpenMapingDonedrawer}
            selectedData={selectedData}
            GetData={GetData}
          />
        ) : null}
      </Drawer>
      {/* <Loader open={openLoader} /> */}
    </>
  );
};
export default PolicyMapping;
